// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"Dropdown_dropdown__ZDwew"};